// Date formatting helper
export const formatDate = (timestamp) => {
  if (!timestamp) return 'N/A';
  
  // Handle Firestore Timestamp objects
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  
  if (isNaN(date.getTime())) return 'N/A';
  
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  
  return `${month}/${day}/${year}`;
};

// Address formatting helper
export const formatAddress = (address) => {
  if (!address) return 'No address';

  // If address is already a string, just return it
  if (typeof address === 'string') {
    return address || 'No address';
  }

  const parts = [];

  // New nested address object schema
  if (address.streetNumber && address.streetName) {
    parts.push(`${address.streetNumber} ${address.streetName}`);
  }

  const cityStateZip = [];
  if (address.city) cityStateZip.push(address.city);
  if (address.state) cityStateZip.push(address.state);
  if (address.zip) cityStateZip.push(address.zip);

  if (cityStateZip.length > 0) {
    parts.push(cityStateZip.join(' '));
  }

  return parts.join(', ') || 'No address';
};

// Truncate text helper
export const truncateText = (text, maxLength = 60) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};
